import React from "react";
import "./loader.css";

const LoaderComponent = () => {
  return <div className="loaderStyle"></div>;
};

export default LoaderComponent;
